import { nanoid } from "@reduxjs/toolkit";
import { getRoles } from "../apis/roles";
import {
  readRolesPage,
  roleErrorMessage,
} from "../../sections/@dashboard/desigination/roleApiHelpers";
import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  desiginations: [],
  roles: [],
  rolesFranchiseId: "",
  rolesLoading: false,
  rolesError: null,
  rolesRequestId: null,
  desigination: null,
};

const slice = createSlice({
  name: "desigination",
  initialState,
  reducers: {
    rolesStarted(state, { payload }) {
      state.roles = [];
      state.rolesLoading = true;
      state.rolesError = null;
      state.rolesFranchiseId = payload.franchiseId;
      state.rolesRequestId = payload.requestId;
    },
    rolesLoaded(state, { payload }) {
      if (state.rolesRequestId !== payload.requestId) return;
      state.roles = payload.roles;
      state.rolesLoading = false;
    },
    rolesFailed(state, { payload }) {
      if (state.rolesRequestId !== payload.requestId) return;
      state.roles = [];
      state.rolesLoading = false;
      state.rolesError = payload.error;
    },
    invalidateRoles(state) {
      state.roles = [];
      state.rolesFranchiseId = "";
    },
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CATEGORIES
    getDesiginationsSuccess(state, action) {
      state.isLoading = false;
      state.desiginations = action.payload;
    },

    // GET CATEGORY
    getDesiginationSuccess(state, action) {
      state.isLoading = false;
      state.desigination = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export const { invalidateRoles } = slice.actions;

// Actions
// export const {
// } = slice.actions;

// ----------------------------------------------------------------------

export function getDesiginations(franchiseId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/desiginations?franchiseId=${franchiseId}`
      );
      dispatch(slice.actions.getDesiginationsSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getDesigination(desiginationId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/desiginations/${desiginationId}`
      );
      dispatch(slice.actions.getDesiginationSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Load all active roles for each dropdown, including every server page.
export const loadActiveRoles = (franchiseId) => async (dispatch) => {
  const requestId = nanoid();
  dispatch(slice.actions.rolesStarted({ franchiseId, requestId }));
  try {
    const groups = await Promise.all(
      ["franchise", "venue", "warehouse"].map(async (scope) => {
        let page = 1;
        const roles = [];
        let totalPages;
        do {
          const result = readRolesPage(
            await getRoles({
              franchiseId,
              scope,
              status: "active",
              page,
              limit: 100,
            })
          );
          roles.push(
            ...result.results.filter(
              (role) => role.status === "active" && role.scope === scope
            )
          );
          totalPages = result.totalPages;
          page += 1;
        } while (page <= totalPages);
        return roles;
      })
    );
    dispatch(slice.actions.rolesLoaded({ requestId, roles: groups.flat() }));
  } catch (error) {
    dispatch(
      slice.actions.rolesFailed({ requestId, error: roleErrorMessage(error) })
    );
  }
};
